export default {
  login(state) {
    state.isUserAuth = true;
  }
}